import type { CustomIconProps } from '../types';

const CopyLink = ({ width, height, color, dataTestId, ...props }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '18'}
        height={height ?? '10'}
        viewBox="0 0 18 10"
        fill="none"
        data-testid={dataTestId}
        {...props}
    >
        <path
            d="M6.35 8.75H4.75C3.68913 8.75 2.67172 8.32857 1.92157 7.57843C1.17143 6.82828 0.75 5.81087 0.75 4.75C0.75 3.68913 1.17143 2.67172 1.92157 1.92157C2.67172 1.17143 3.68913 0.75 4.75 0.75H6.35"
            stroke={color ?? '#414042'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.15 0.75H12.75C13.8109 0.75 14.8283 1.17143 15.5785 1.92157C16.3286 2.67172 16.75 3.68913 16.75 4.75C16.75 5.81087 16.3286 6.82828 15.5785 7.57843C14.8283 8.32857 13.8109 8.75 12.75 8.75H11.15"
            stroke={color ?? '#414042'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.55005 4.75H11.95"
            stroke={color ?? '#414042'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CopyLink;
